import store from "@frameworks/web/redux/store";
import { IPOOTPLEADS_DATA, IPOOTPLEADS_ERROR_DATA, IPOOTPLEADS_HIDE_ERROR_DATA, IPOOTPLEADS_START_LOADER, IPOOTPLEADS_STOP_LOADER, } from "../interface/IpoOtpLeads";
class IpoOtpLeadsActiton {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getIpoOtpLeads(IpoOtpLeads) {
        this.dispatch({
            type: IPOOTPLEADS_DATA,
            payload: { IpoOtpLeads },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: IPOOTPLEADS_ERROR_DATA,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: IPOOTPLEADS_HIDE_ERROR_DATA,
        });
    }
    startLoader() {
        this.dispatch({
            type: IPOOTPLEADS_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: IPOOTPLEADS_STOP_LOADER,
        });
    }
}
export default IpoOtpLeadsActiton;
